// src/api/tickets.js
import api from "./api";

export const TicketsAPI = {
  list: (filters = {}) => {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const qs = params.toString();
    return api(`/tickets${qs ? `?${qs}` : ""}`);
  },

  get: (id) => api(`/tickets/${id}`),

  dashboard: () => api("/tickets/dashboard"),

  filterOptions: () => api("/tickets/filter-options"),

  assignableUsers: (schoolId, departmentId) =>
  api(
    `/tickets/assignable-users?school_id=${encodeURIComponent(
      schoolId
    )}&department_id=${encodeURIComponent(departmentId)}`
  ),

  assignedToMe: () => api("/tickets/assigned-to-me"),

  create: (data) =>
    api("/tickets", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  update: (id, patch) =>
    api(`/tickets/${id}`, {
      method: "PATCH",
      body: JSON.stringify(patch),
    }),

  listMessages: (id) => api(`/tickets/${id}/messages`),

  listOtherRaised: (id) => api(`/tickets/${id}/other-raised`),

  allowedSchools: (permissionKey = "tickets.view") =>
    api(
      `/tickets/allowed-schools?permission=${encodeURIComponent(permissionKey)}`
    ),

  addMessage: (id, data) => {
    const isFormData = data instanceof FormData;

    return api(`/tickets/${id}/messages`, {
      method: "POST",
      body: isFormData ? data : JSON.stringify(data),
    });
  },
};